import React, { useEffect } from 'react';
import Player from '../../../components/xr/player';
import { VideoSpaceResourceId } from '../../../common/constants/xr';
import { useLocation } from 'react-router-dom';
import qs from 'qs';
import { useSelector } from 'react-redux';
import { RootState } from '../../../types/data';
import { MathUtils } from 'three';
import { MediaType, MediaEvents } from '../../../common/media';
import { useMedia } from '../../../hooks';
import GatewayService from '../../../services/gateway-service';
import { STORY_ENDED } from '../../../common/constants/gateway-events';

const { degToRad } = MathUtils;

const ActionVideoSpace = () => {
  const place = useSelector<RootState, any>(state => state.place.current);
  const location = useLocation();
  const media = useMedia(VideoSpaceResourceId, MediaType.Video);
  const query = qs.parse(location.search, { ignoreQueryPrefix: true });
  const showPlayer = Number(query.playerMode) !== 2;

  useEffect(() => {
    const handleEnd = () => GatewayService.emit(STORY_ENDED, place.data);

    media.on(MediaEvents.Ended, handleEnd);

    return () => {
      media.off(MediaEvents.Ended, handleEnd);
    };
  }, [media, place.data]);

  return (
    <group>
      <group position={[0, 0, 0]}>
        <group position={[0, -0.5, -1]} scale={[1.5, 1.5, 1.5]} rotation={[degToRad(-15), 0, 0]}>
          {showPlayer ? <Player position={[0, 0, 0]} target={VideoSpaceResourceId} mode="video" /> : null}
        </group>
      </group>
    </group>
  );
};

export default ActionVideoSpace;
